<template>
  <div class="firstclassifi">
    <div class="firstclassifi-div">
      <div class="firstclassifi-div-first">
        <div class="firstclassifi-div-first-addition" @click="additionClick">
          <img
            class="first-addition-img"
            src="../../assets/common/common-add.png"
          />
          <div class="first-addition-title">添加</div>
        </div>

        <div class="firstclassifi-div-first-unfold">展示</div>
      </div>
      <div class="firstclassifi-div-second">
        <el-table
          :data="tableData"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>

          <el-table-column
            prop="name"
            label="一级分类"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="title"
            label="二级分类"
            width="140"
          ></el-table-column>
          <el-table-column prop="commondityName" label="二级分类图标">
            <template slot-scope="scope">
              <div class="table-cover">
                <img class="table-cover-img" :src="scope.row.img" alt="" />
              </div>
            </template>
          </el-table-column>

          <el-table-column label="二级分类状态" width="160">
            <template slot-scope="scope">
              {{ scope.row.commondityStatus == '0' ? '展示' : '隐藏' }}
            </template>
          </el-table-column>
          <el-table-column label="二级分类商品设置" width="160">
            <template slot-scope="scope">
              <div class="table-set" @click="commditySet(scope.row)">
                商品设置
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" width="200">
            <template slot-scope="scope">
              <div class="table-sort">
                <img
                  class="table-sort-left"
                  :src="
                    scope.row.size == false
                      ? require('../../assets/marketing/marketing-forbid-up.png')
                      : require('../../assets/marketing/marketing-up.png')
                  "
                  alt=""
                />
                <img
                  class="table-sort-right"
                  :src="
                    scope.row.size1 == false
                      ? require('../../assets/marketing/marketing-forbid-below.png')
                      : require('../../assets/marketing/marketing-below.png')
                  "
                  alt=""
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作" width="150">
            <template slot-scope="scope">
              <div class="operation">
                <div class="compile" @click="compileBtn(scope.row)">编辑</div>

                <div class="delete" @click="deteleBtn(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!--一级分类  添加弹出框-->
    <div class="addition">
      <el-dialog
        :visible.sync="additionDialogVisible"
        width="444px"
        style="margin-top: 15vh"
        :show-close="false"
      >
        <span slot="footer" class="dialog-footer">
          <div class="addition-div">
            <div class="addition-div-top">
              <div class="div-top-title">
                {{ compileShow == false ? '二级分类添加' : '商品编辑' }}
              </div>
              <img class="div-top-close" src="../../assets/common/close.png" />
            </div>

            <div class="addition-div-center">
              <div class="center-title">二级分类名称</div>
              <div class="center-input">
                <el-input
                  placeholder="请输入商品名称"
                  v-model="additionTitle"
                  class="input-with-select"
                >
                </el-input>
              </div>

              <div class="center-display">
                <div class="center-display-left">
                  <div class="center-display-left-title">二级分类图标</div>
                  <div class="center-display-left-uploading">
                    <div class="uploading" v-if="compileShow == false">
                      <img
                        class="uploading-img"
                        src="../../assets/common/common-uploading.png"
                      />
                      <div class="uploading-text">上传图片</div>
                    </div>

                    <img
                      class="center-display-left-uploading-img"
                      v-else
                      src="../../assets/activities/activities-simulation.png"
                    />
                  </div>
                </div>
                <div class="center-display-right">
                  <div class="center-display-right-title">二级状态</div>
                  <div class="center-display-right-check">
                    <div class="center-display-right-check-show">
                      <el-radio v-model="additionRadio" label="1"
                        >展示</el-radio
                      >
                    </div>
                    <div class="center-display-check-right-conceal">
                      <el-radio v-model="additionRadio" label="2"
                        >隐藏</el-radio
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="addition-div-button">
              <div class="addition-div-button-reset">重置</div>
              <div class="addition-div-button-confirm">确定</div>
            </div>
          </div>
        </span></el-dialog
      >
    </div>

    <!-- 第二区域  删除 -->
    <div class="detele">
      <el-dialog
        :visible.sync="deteleDialogVisible"
        width="394px"
        style="margin-top: 10vh"
      >
        <span slot="footer" class="dialog-footer">
          <div class="detele-div">
            <img
              class="detele-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="detele-div-title">请重新确定是否删除？</div>
            <div class="detele-div-text">
              一旦确定后，则删除该一级分类，包括关联的商品和二级分类也将删除。
            </div>
            <div class="detele-div-button">
              <div class="detele-div-button-left" @click="confirmDetele">
                确定
              </div>
              <div class="detele-div-button-right" @click="cancelDetele">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Bus from '../../utils/bus'

export default {
  data() {
    return {
      // 第二模块 表格数组数据
      tableData: [
        {
          name: '每日新品',
          title: '每日新品',
          img: require('../../assets/activities/activities-simulation.png'),
          selling: '676',
          lintPrize: '387',
          commondityStatus: '0',
          size: true, // true 表示置顶
          size1: false, // true 表示置底
        },
      ],

      // 添加弹出框区域
      additionDialogVisible: false,
      // 添加弹出框 二级分类名称
      additionTitle: '',
      // 添加弹出框 单选
      additionRadio: '1',
      // 编辑弹出框 图片
      editImg: '',
      // end

      // 商品区域 编辑区域  判断用户是从编辑点击区域进入
      compileShow: false,
      /* 删除弹出框 */
      deteleDialogVisible: false,
    }
  },
  created() {},
  methods: {
    // 用户点击添加按钮开启弹出框
    additionClick() {
      this.compileShow = false
      this.additionDialogVisible = true
    },
    /*end */

    // 商品列表区域
    compileBtn(e) {
      this.compileShow = true
      this.additionRadio = '2'
      this.additionTitle = '一品一县'

      this.$nextTick(() => {
        this.additionDialogVisible = true
      })
    },

    // 用户点击二级分类设置商品列表中  商品设置
    commditySet(item) {
      Bus.$emit('log', 'marketingSecondcommdityclassifi', item)
    },
    /* 删除 */
    // 开启删除弹出框
    deteleBtn(e) {
      this.deteleDialogVisible = true
    },
    // 确定删除框
    confirmDetele() {
      this.deteleDialogVisible = false
    },

    // 取消删除弹出框
    cancelDetele() {
      this.deteleDialogVisible = false
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.firstclassifi {
  background: #ffffff;
  height: 100%;
  .firstclassifi-div {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px;
    padding-bottom: 24px;
    box-sizing: border-box;
    .firstclassifi-div-first {
      height: 80px;
      display: flex;
      align-items: center;

      .firstclassifi-div-first-addition {
        width: 82px;
        height: 36px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .first-addition-img {
          width: 13px;
          height: 13px;
        }

        .first-addition-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          margin-left: 8px;
        }
      }

      .firstclassifi-div-first-unfold {
        width: 82px;
        height: 36px;
        border-radius: 10px;
        border: 1px solid #36c100;
        margin-left: 12px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #36c100;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
      }
    }

    .firstclassifi-div-second {
      /deep/ .el-table .el-table__cell {
        padding: 13px 0;
        vertical-align: top;
      }
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;
        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }
      .table-cover {
        width: 70;
        height: 70px;
        .table-cover-img {
          width: 70;
          height: 70px;
          background: #e9edf4;
        }
      }
      .table-set {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
      }

      .table-sort {
        display: flex;

        .table-sort-left,
        .table-sort-right {
          width: 26px;
          height: 26px;
        }

        .table-sort-right {
          margin-left: 4px;
        }
      }

      .operation {
        display: flex;

        .compile,
        .delete {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
        }

        .delete {
          margin-left: 24px;
        }
      }
    }
  }

  /* 添加 */
  .addition {
    /deep/ .el-dialog {
      height: 350px;
    }
    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }
    .addition-div {
      .addition-div-top {
        display: flex;
        height: 56px;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #e9edf4;

        .div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }

        .div-top-close {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
      }

      .addition-div-center {
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 20px;
        width: 100%;
        .center-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .center-input {
          width: 100%;
          height: 32px;
          margin-top: 4px;
          margin-bottom: 16px;
          /deep/ .el-autocomplete {
            width: 100%;
          }

          /deep/ .el-input {
            width: 100%;
            height: 32px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }
        }

        .center-display {
          display: flex;
          margin-top: 14px;
          .center-display-left {
            .center-display-left-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .center-display-left-uploading {
              margin-top: 8px;
              width: 100px;
              height: 100px;
              background: rgba(0, 0, 0, 0.02);
              border-radius: 5px;
              display: flex;
              align-items: center;
              justify-content: center;

              .uploading {
                text-align: center;
                .uploading-img {
                  width: 24px;
                  height: 24px;
                }

                .uploading-text {
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;
                }
              }

              .center-display-left-uploading-img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .center-display-right {
            margin-left: 52px;
            .center-display-right-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .center-display-right-check {
              display: flex;
              margin-top: 9px;

              .center-display-right-check-show,
              .center-display-check-right-conceal {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #222222;
              }

              .center-display-check-right-conceal {
                margin-left: 28px;
              }
            }
          }
        }
      }

      .addition-div-button {
        display: flex;
        height: 52px;
        align-items: center;
        justify-content: flex-end;
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 22px;
        border-top: 1px solid #e9edf4;

        .addition-div-button-reset,
        .addition-div-button-confirm {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          cursor: pointer;
        }

        .addition-div-button-confirm {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }
  }

  /* 右侧删除弹出框 */
  .detele {
    /deep/ .el-dialog {
      height: 231px;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      box-sizing: border-box;
    }

    .detele-div {
      width: 100%;
      text-align: center;
      padding-top: 25px;
      .detele-div-img {
        width: 56px;
        height: 56px;
        margin: 0 auto;
      }

      .detele-div-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
      }

      .detele-div-text {
        width: 319px;
        height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin: 0 auto;
        margin-top: 2px;
      }

      .detele-div-button {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 18px;

        .detele-div-button-left,
        .detele-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }

        .detele-div-button-right {
          margin-left: 8px;
          border: 1px solid #e9edf4;
          color: rgba(0, 0, 0, 0.65);
          background: #ffffff;
        }
      }
    }
  }
}
</style>
